import { classNames } from "../utils/cn";
import { ButtonVariant } from "./tailwind/Button";

const styles: Record<ButtonVariant, string> = {
  neutral: "border-gray-200 bg-white/80 text-gray-400",
  "neutral/inverted": "border-gray-200 bg-white/80 text-gray-400",
  positive: "bg-persian-500 border-persian-300/50    text-persian-100",
  "positive/inverted":
    "bg-persian-500 border-persian-300/50    text-persian-100",
  danger: "bg-red-100/80 border-red-200 text-red-600",
  green: "bg-green-100/80 border-green-200 text-green-600",
  "neutral/soft": "bg-concrete-100/80 border-concrete-200 text-concrete-800",
  secondary: "bg-persian-400 border-persian-200 text-persian-950",
};

export function KeyboardShortcut(props: {
  shortcut: string;
  variant?: ButtonVariant;
}) {
  return (
    <kbd
      className={classNames(
        "pointer-events-none font-mono text-xs justify-center border  rounded-sm  ml-auto flex items-center py-px px-1.5 font-semibold select-none",
        styles[props.variant || "neutral"],
      )}
    >
      {props.shortcut}
    </kbd>
  );
}
